<template>
    <!-- 科目管理 列表页 -->
    <div class="board">
        <div v-hasPermi="['subject:subject:list']">
            <div class="title">
                <span class="name">{{ subjectTextConfig.name }}</span>
                <div>
                    <el-button v-hasPermi="['subject:subject:add']" type="primary" @click="editDialogVisible = true, row = {}">
                        {{ subjectTextConfig.button.create }}
                    </el-button>
                    <!--                    <el-button v-hasPermi="['subject:subject:upload']" type="primary" @click="importDialogVisible = true">-->
                    <!--                        {{ subjectTextConfig.button.import }}</el-button>-->
                </div>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-input v-model="form.name" clearable :placeholder="subjectTextConfig.subjectName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.credential_level" clearable :placeholder="subjectTextConfig.credentialLevel">
                        <el-option v-for="item in gradeOptions" :key="item.dict_value" :label="item.dict_label" :value="item.dict_value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.credential_number" clearable :placeholder="subjectTextConfig.credentialNumber"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.credential_name" clearable :placeholder="subjectTextConfig.credentialName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.exam_type" clearable :placeholder="subjectTextConfig.examType">
                        <el-option v-for="item in typeOptions" :key="item.dict_value" :label="item.dict_label" :value="item.dict_value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.status" clearable :placeholder="subjectTextConfig.subjectStatus">
                        <el-option v-for="item in statusOptions" :key="item.dict_value" :label="item.dict_label" :value="item.dict_value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ subjectTextConfig.button.select }}</el-button>
                    <el-button @click="reset">{{ subjectTextConfig.button.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                      ref="multipleTable" stripe size="medium" :height="height" style="width:100%">
                <!-- <el-table-column prop="id" label="科目编号" :min-width="flexColumnWidth('id',5,tableData)" show-overflow-tooltip></el-table-column> -->
                <el-table-column prop="name" :label="subjectTextConfig.subjectName" :min-width="flexColumnWidth('name',4,tableData)"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="credential_level" :label="subjectTextConfig.credentialLevel" min-width="80px"></el-table-column>
                <el-table-column prop="credential_number" :label="subjectTextConfig.credentialNumber"
                                 :min-width="flexColumnWidth('credential_number',4,tableData)" show-overflow-tooltip></el-table-column>
                <el-table-column prop="credential_name" :label="subjectTextConfig.credentialName"
                                 :min-width="flexColumnWidth('credential_name',4,tableData)" show-overflow-tooltip></el-table-column>
                <el-table-column prop="exam_type" :label="subjectTextConfig.examType" min-width="80px"></el-table-column>
                <el-table-column prop="update" :label="subjectTextConfig.lastUpdate" min-width="125px">
                    <template slot-scope="scope">
                        <p>{{ scope.row.updated_by_username }}</p>
                        <p class="updateDate">{{ scope.row.updated_at }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="question_bank_num" :label="subjectTextConfig.subjectStatus" min-width="80px">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status==0?'info':''">{{ formatterSubjectStatus(scope.row.status) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="subjectTextConfig.operate" min-width="145px">
                    <template slot-scope="scope">
                        <el-button v-hasPermi="['subject:subject:update']" size="mini" plain type="primary" @click="edit(scope.row)"
                                   :disabled="scope.row.status === 1">
                            {{ subjectTextConfig.button.edit }}
                        </el-button>
                        <el-button v-hasPermi="['subject:subject:delete']" size="mini" plain type="danger" @click="delet(scope.row.id)"
                                   :disabled="scope.row.status === 1">
                            {{ subjectTextConfig.button.delete }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.page_number" :pageSize.sync="form.page_size"
                        :total.sync="total"></pagination>
            <edit-dialog :row.sync="row" :show.sync="editDialogVisible" @close="close"></edit-dialog>
            <import-dialog :show.sync="importDialogVisible" @close="close"></import-dialog>
        </div>
    </div>
</template>

<script>
import editDialog from './dialog/edit.vue'
import importDialog from './dialog/import.vue'
import pagination from '@/components/pagination/pagination.vue'

export default {
    components: {
        editDialog, importDialog, pagination
    },
    data() {
        return {
            height: 250,
            loading: true,
            form: {
                name: '',
                credential_level: '',
                credential_number: '',
                credential_name: '',
                exam_type: '',
                status: '',
                page_number: 1,
                page_size: 20
            },
            total: 0,
            gradeOptions: [],
            typeOptions: [],
            statusOptions: [],
            tableData: [],
            editDialogVisible: false,
            importDialogVisible: false,
            row: null,
        }
    },
    computed: {
        subjectTextConfig() {
            return this.$store.state.global.textConfig.backend.subject
        }
    },
    watch: {
        tableData() {
            if (this.tableData.length == 0) {
                this.height = 120
            } else {
                this.updateHeight()
            }
        }
    },
    created() {
        this.$store.dispatch("getDict", 'exam_method').then(res => {
            this.typeOptions = res.data
        });
        this.$store.dispatch("getDict", 'credential_level').then(res => {
            this.gradeOptions = res.data
        });
        this.$store.dispatch("getDict", 'subject_status').then(res => {
            this.statusOptions = res.data
        });
        this.search(1)
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    methods: {
        formatterSubjectStatus(val) {
            let already = this.statusOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        search(val) {
            this.loading = true
            if (val) {
                this.form.page_number = val
            }
            this.$store.dispatch("getSubjectList", this.form).then(res => {
                if (res.status == 200) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                    this.form.page_number = res.data.pageNumber
                }
                this.loading = false
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            }).catch(err => {
                console.log(err);
                this.loading = false
            })
        },
        reset() {
            this.form = this.$options.data().form
            this.form.page_size = 20
            this.search(1)
        },
        edit(row) {
            this.row = row
            this.editDialogVisible = true
        },
        delet(id) {
            this.$confirm(this.subjectTextConfig.delete.message, this.subjectTextConfig.delete.title, {
                confirmButtonText: this.subjectTextConfig.delete.ok,
                cancelButtonText: this.subjectTextConfig.delete.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deleteSubject", id).then(res => {
                    this.$message({
                        type: 'success',
                        message: this.subjectTextConfig.delete.success
                    });
                    if (this.tableData.length == 1) {
                        let num = this.form.page_number == 1 ? 1 : this.form.page_number - 1
                        this.search(num)
                    } else {
                        this.search()
                    }
                });
            }).catch(() => {
            });

        },
        close(data) {
            this.editDialogVisible = data
            this.importDialogVisible = data
            this.row = {}
        },
        updateHeight() {
            if (document.getElementsByClassName('el-form')[0]) {
                this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 150
                this.height = this.height < 460 ? 460 : this.height
            }
        }
    }
}
</script>

<style scoped>
</style>